function getBaseUrl() {
  const href = window.location.href;
  const [protocol, , server] = href.split('/');
  return `${protocol}//${server}`;
}

export default getBaseUrl;
